import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { decode, encode } from "base-64";
import { api } from "../../../utlis/staff/api.utlis";
import Loader from "../../../layouts/loader/Loader";
import ApiService from "../../../core/services/ApiService";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import StarImg from "../../../assets/user/images/star.svg";
import DollarImg from "../../../assets/user/images/dollar-circle.svg";
import BriefcaseImg from "../../../assets/user/images/briefcase.svg";
import HouseImg from "../../../assets/user/images/house.svg";
import HandshakeImg from "../../../assets/user/images/Handshake.svg";
import StarWhImg from "../../../assets/user/images/starwh.svg";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import TrashImg from "../../../assets/user/images/trash.svg";
import uploadImage from "../../../assets/admin/images/uploadImage.svg";
import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import moment from "moment/moment";
import toast from "react-hot-toast";
import { routes } from "../../../utlis/staff/routes.utlis";
import { SingleFile } from "../../../utlis/common.utlis";

const ShareProfile = () => {
  const navigate = useNavigate();
  const localData = useLocation();
  const id = localData.state?.id;
  const [list, setShareList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectCommunity, setSelectCommunity] = useState("");
  const [tab, setTab] = useState(1);

  const initialFirstValues = {
    community_id: selectCommunity ?? "",
  };

  const initialSecondValues = {
    poll_title: "",
    description: "",
    post_image: "",
    poll: "no",
    options: [""],
  };

  const validationFirstSchema = Yup.object().shape({
    community_id: Yup.string().required("Please select community"),
  });

  const validationSecondSchema = Yup.object().shape({
    poll_title: Yup.string().required("Title is required!"),
    description: Yup.string().required("Description is required!"),
    post_image: Yup.mixed()
      .test(
        "fileSize",
        "File size is too large",
        (value) => !value || (value && value.size <= SingleFile * 1024 * 1024)
      )
      .test("fileType", "Unsupported file type", (value) => {
        return value != "" && value != null && value != undefined
          ? ["image/jpeg", "image/png", "image/jpg"].includes(value.type)
          : true;
      }),
    poll: Yup.string().required("Please select Yes or No"),
  });

  const firstStep = async (formValue) => {
    setLoading(true);
    setSelectCommunity(formValue.community_id);
    setTab(2);
    setLoading(false);
  };

  const secondStep = async (formValue) => {
    setLoading(true);
    let form = new FormData();
    form.append("profile_id", decode(id));
    form.append("community_id", selectCommunity);
    form.append("poll_title", formValue.poll_title);
    form.append("description", formValue.description);
    if (formValue.post_image) {
      form.append("post_image", formValue.post_image);
    }
    if (formValue.options.length !== 0) {
      formValue.options
        .filter((opt) => opt && opt.trim() !== "")
        .forEach((opt) => form.append("poll_options[]", opt));
    }
    const response = await ApiService.postAPIWithAccessTokenMultiPart(
      api.shareProfile,
      form
    );
    if (response.data.status) {
      toast.success(response.data.message);
      navigate(routes.communityInfo, {
        state: {
          id: encode(selectCommunity),
        },
      });
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const getCreatedList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      setShareList(response.data.data.communityList);
    } else setShareList([]);
    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getCreatedList(api.shareCommunityList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container">
        <div className="carenetwork-section">
          <div className="care-title-header">
            <h2 className="heading-title my-3">Share Profile</h2>
          </div>

          <div className="ce-step-list">
            <ul id="progressbar" className="nav steps nav-tabs">
              <li
                className={
                  tab == 1 || tab == 2 ? "active nav-item" : "nav-item"
                }
              >
                <Link className={tab == 1 || tab == 2 ? "active" : ""}>
                  <span className="number">1</span>
                </Link>
              </li>
              <li className={tab == 2 ? "active nav-item" : "nav-item"}>
                <Link className={tab == 1 || tab == 2 ? "active" : ""}>
                  <span className="number">2</span>
                </Link>
              </li>
            </ul>
          </div>
          <div className="findcare-content">
            <div className="step-content tab-content">
              {tab == 1 ? (
                <div className="tab-pane fade active show" id="tab1">
                  <div className="findcare-form">
                    <h2>Share with the community</h2>
                    <div className="findcare-card">
                      <Formik
                        initialValues={initialFirstValues}
                        validateOnChange={true}
                        validationSchema={validationFirstSchema}
                        onSubmit={firstStep}
                      >
                        {({ values, setFieldValue }) => (
                          <Form className="findcare-form">
                            <div className="form-group">
                              <div className="choosepayment-list">
                                <ul>
                                  {list.length !== 0
                                    ? list.map((ele, indx) => {
                                        return (
                                          <li key={indx} className="mb-2 p-3 w-50">
                                            <div className="choosecategoriesradio">
                                              <Field
                                                type="radio"
                                                name="community_id"
                                                id={`${ele.id}categories`}
                                                value={`${ele.id}`}
                                              />
                                              <label
                                                htmlFor={`${ele.id}categories`}
                                              >
                                                <div className="categories-card d-flex align-items-center">
                                                  <div className="community-head-media-1">
                                                    {ele?.cover_image
                                                      ?.length === 0 ||
                                                    ele?.cover_image === null ||
                                                    ele?.cover_image === "" ||
                                                    ele?.cover_image ===
                                                      undefined ? (
                                                      <img
                                                        src={NoImage}
                                                        alt=""
                                                      />
                                                    ) : (
                                                      <img
                                                        style={{
                                                          objectFit: "cover",
                                                          objectPosition:
                                                            "center",
                                                        }}
                                                        src={
                                                          ele?.cover_image[0]
                                                            ?.image
                                                        }
                                                        alt=""
                                                      />
                                                    )}
                                                  </div>
                                                  <div className="categories-text mx-2 text-capitalize">
                                                    {ele.title ?? "NA"}
                                                  </div>
                                                </div>
                                              </label>
                                            </div>
                                          </li>
                                        );
                                      })
                                    : null}
                                </ul>
                                <ErrorMessage
                                  name="community_id"
                                  component="div"
                                  className="alert alert-danger"
                                />
                              </div>
                            </div>
                            <div className="form-group text-end">
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  navigate(-1);
                                }}
                                className="btn btn-re me-2"
                                data-bs-dismiss="modal"
                              >
                                Cancel
                              </button>
                              <button
                                type="submit"
                                className="btn btn-gr me-2"
                                data-bs-dismiss="modal"
                              >
                                Next Page
                              </button>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              ) : null}

              <div
                className={tab == 2 ? "tab-pane show" : "tab-pane d-none"}
                id="tab2"
              >
                <div className="findcare-form">
                  <h2>Enter A Few Details More</h2>
                  <div className="findcare-card">
                    <Formik
                      initialValues={initialSecondValues}
                      validateOnChange={true}
                      validationSchema={validationSecondSchema}
                      onSubmit={secondStep}
                      enableReinitialize
                    >
                      {({ values, setFieldValue }) => (
                        <Form className="findcare-form" id="add-post-form">
                          <div className="form-group">
                            <h4>Title</h4>
                            <Field
                              type="text"
                              className="form-control todo-list-input"
                              name="poll_title"
                              placeholder="Enter Title"
                            />
                            <ErrorMessage
                              name="poll_title"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                          <div className="form-group">
                            <h4>
                              Upload Image{" "}
                              <span
                                className="text-danger"
                                style={{ fontSize: "0.7rem" }}
                              >
                                (In JPG, JPEG & PNG)
                              </span>
                            </h4>
                            <div className="upload-signature">
                              <Field name="post_image">
                                {({ field, form }) => (
                                  <>
                                    <input
                                      type="file"
                                      id="files"
                                      accept="image/jpg, image/jpeg, image/png"
                                      className="form-control addsignature todo-list-input"
                                      style={{ position: "absolute" }}
                                      onChange={(event) =>
                                        setFieldValue(
                                          "post_image",
                                          event.currentTarget.files[0]
                                        )
                                      }
                                    />
                                    <label for="files">
                                      <div className="signature-text">
                                        <span>
                                          <img src={uploadImage} alt="" />
                                          <small className="prev-filename">
                                            {values?.post_image?.name
                                              ? values?.post_image?.name
                                              : "Click here to Upload Image"}
                                          </small>
                                        </span>
                                      </div>
                                    </label>
                                  </>
                                )}
                              </Field>
                              <ErrorMessage
                                name="post_image"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <h4>Description</h4>
                            <Field
                              type="text"
                              as="textarea"
                              className="form-control"
                              name="description"
                              placeholder="Enter Description"
                              style={{ height: "150px" }}
                            />
                            <ErrorMessage
                              name="description"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                          <div className="form-group">
                            <h4>Create Poll</h4>
                            <div className="choosemiles-list">
                              <ul>
                                <li>
                                  <div className="ceradio">
                                    <Field
                                      type="radio"
                                      name="poll"
                                      id="Hour"
                                      value="yes"
                                    />
                                    <label for="Hour">
                                      <span className="checkbox-text">
                                        {" "}
                                        Yes
                                      </span>
                                    </label>
                                  </div>
                                </li>
                                <li>
                                  <div className="ceradio">
                                    <Field
                                      type="radio"
                                      name="poll"
                                      id="Daily"
                                      value="no"
                                    />
                                    <label for="Daily">
                                      <span className="checkbox-text"> No</span>
                                    </label>
                                  </div>
                                </li>
                              </ul>
                              <ErrorMessage
                                name="pay_range_type"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>
                          {values.poll == "yes" ? (
                            <div className="form-group">
                              <FieldArray name="options">
                                {({ push, remove }) => (
                                  <div>
                                    {values.options.map((option, index) => (
                                      <div
                                        key={index}
                                        style={{
                                          display: "flex",
                                          marginBottom: "10px",
                                        }}
                                      >
                                        <Field
                                          name={`options.${index}`}
                                          placeholder={`Enter Poll Options`}
                                          className="form-control me-3"
                                        />
                                        <button
                                          type="button"
                                          className="btn-re"
                                          onClick={() => remove(index)}
                                          disabled={values.options.length === 0}
                                        >
                                          <img src={TrashImg} />
                                        </button>
                                      </div>
                                    ))}
                                    <ErrorMessage
                                      name="options"
                                      component="div"
                                      className="alert alert-danger"
                                    />
                                    <button
                                      type="button"
                                      className="btn-gr"
                                      onClick={() => push("")}
                                    >
                                      <i className="fa fa-plus"></i>
                                    </button>
                                  </div>
                                )}
                              </FieldArray>
                            </div>
                          ) : null}
                          <div className="form-group text-end">
                            <button
                              type="button"
                              onClick={(e) => {
                                e.preventDefault();
                                setTab(1);
                              }}
                              className="btn btn-re me-2"
                              data-bs-dismiss="modal"
                            >
                              Previous Page
                            </button>
                            <button
                              type="submit"
                              className="btn btn-gr me-2"
                              data-bs-dismiss="modal"
                            >
                              Share
                            </button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareProfile;
